import axiosInstance from './axiosInstance'

// Non-sensitive UTS defaults configured on the backend (origin zip, payment
// type, whether credentials are present). Used to pre-fill the rate estimate
// UI so the user doesn't have to retype the warehouse zip every time.
export const getUtsConfig = () => {
  return axiosInstance.get('/uts/config')
}

// Request a full carrier rate estimate from UTS for a list of crates.
// `data` shape:
//   {
//     crates: [{ lengthFt, widthIn, heightFt, totalWeightLb, freightClass }, ...],
//     originZip?: string,           // defaults to UTS_ORIGIN_ZIP on the backend
//     destinationZip: string,
//     originLocationId?: number,
//     destinationLocationId?: number,
//     paymentType?: 'PREPAID' | 'COLLECT' | 'THIRD_PARTY' | 'PREPAID_ADD',
//     billToID?: number,
//     includeGuaranteedRates?: boolean,
//     accessorials?: [{ code, name }],
//     lineItemOpts?: { isStackable, isHazMat, isMixedCommodity }
//   }
export const getUtsRateEstimate = (data) => {
  return axiosInstance.post('/uts/rate-estimate', data)
}

export const getUtsRateEstimateLite = (data) => {
  return axiosInstance.post('/uts/rate-estimate-lite', data)
}
